var _rect, _g, _ellipse, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqlalchemy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "SQLAlchemy logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 6,
    ry: 6,
    fill: "#0F1722"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6,6)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 30 L16 8",
    fill: "none",
    stroke: "#6CC4A1",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 30 L24 8",
    fill: "none",
    stroke: "#6CC4A1",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18 C18 14, 24 14, 30 18",
    fill: "none",
    stroke: "#2EA57B",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 6 L21 10 L27 10 Z",
    fill: "#2EA57B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18 C18 14, 24 14, 30 18",
    fill: "none",
    stroke: "rgba(0,0,0,0.12)",
    strokeWidth: 0.8,
    transform: "translate(0,0.8)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 14,
    rx: 8,
    ry: 3,
    fill: "rgba(255,255,255,0.04)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 41.5,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 6.2,
    fill: "#E6F8EE",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "sqlalchemy")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlalchemy);
export default __webpack_public_path__ + "static/media/sqlalchemy.57871e7cca4f9f068bf32d3798c47279.svg";
export { ForwardRef as ReactComponent };